// 封装请求方法
import requset from '@/utils/request.js'
// 数据需求方了列表
export const getMapPlatformChinaMap = (data) =>　{
    return requset({
        url:'/xwzx/ow/getMapPlatform',
        method:'GET'
    })
}
export const getMapPlatformMap = (data) =>　{
    return requset({
        url:`/xwzx/ow/getMapPlatform?name=${data}`,
        method:'GET'
    })
}

export const getTwoMapPlatform = (data) =>　{
    return requset({
        url:`/xwzx/ow/getTwoMapPlatform?name=${data}`,
        method:'GET'
    })
}